'use es6';

import { getSenderId } from './commonMessageFormatGetters';
export const getCommonMessageSenderId = ({
  message
}) => {
  const senderId = getSenderId(message);
  return senderId;
};